import { saveAs } from "file-saver";
import { useEffect, useState } from "react";
import DatePicker from "react-datepicker";
import * as XLSX from "xlsx/xlsx.mjs";
import Header from "../../../components/Header";
import Loader from "../../../components/Loader";
import exportIcon from "../../../images/export.svg";
import "react-datepicker/dist/react-datepicker.css";

const Admin = () => {
  const [isLoading, setIsLoading] = useState(false);
  let [employees, setEmployees] = useState([]);
  let [startDate, setStartDate] = useState(new Date());
  let [endDate, setEndDate] = useState(new Date());
  let [toggleCheckInIcon, setToggleCheckInIcon] = useState(false);
  let [toggleCheckoutIcon, setToggleCheckoutIcon] = useState(false);
  const token = localStorage.getItem("token");
  const api_url = process.env.REACT_APP_API_URL;
  const from = startDate.toISOString().split("T")[0];
  const to = endDate.toISOString().split("T")[0];

  useEffect(() => {
    try {
      setIsLoading(true);
      if (token) {
        fetch(api_url + `employees?from=${from}&to=${to}`, {
          method: "GET",
          headers: {
            authorization: token,
          },
        })
          .then((response) => response.json())
          .then((data) => {
            console.log(data);
            setEmployees(data.employees);
            setIsLoading(false);
          });
      }
    } catch (error) {
      console.log(error);
    }
  }, [api_url, token, from, to]);

  // const th_fields = ["code", "name", "phone", "check in", "check out"];
  const db_fields = ["outlet_code", "name", "phone", "checkin", "checkout"];

  const sortCheckIn = () => {
    if (toggleCheckInIcon) {
      employees = employees.sort((a, b) => {
        return a.checkin.split(" ")[0].localeCompare(b.checkin.split(" ")[0]);
      });
    } else {
      employees = employees.sort((a, b) => {
        return b.checkin.split(" ")[0].localeCompare(a.checkin.split(" ")[0]);
      });
    }

    setToggleCheckInIcon((current) => !current);
  };

  const sortCheckOut = () => {
    if (toggleCheckoutIcon) {
      employees = employees.sort((a, b) => {
        return a.checkout.split(" ")[0].localeCompare(b.checkout.split(" ")[0]);
      });
    } else {
      employees = employees.sort((a, b) => {
        return b.checkout.split(" ")[0].localeCompare(a.checkout.split(" ")[0]);
      });
    }

    setToggleCheckoutIcon((current) => !current);
    console.log("From sort function:", employees);
  };

  const exportXlsx = () => {
    const newData = employees.map((emp) => {
      return {
        "staff id": emp.staff_id,
        designation: emp.designation,
        name: emp.name,
        outlet: emp.outlet,
        "outlet code": emp.outlet_code,
        phone: emp.phone,
        "check in": emp.checkin,
        "check out": emp.checkout,
        date: emp.date,
        latitude: emp.latitude,
        longitude: emp.longitude,
        location: emp.location,
      };
    });
    const worksheet = XLSX.utils.json_to_sheet(newData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });
    const data = new Blob([excelBuffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    saveAs(data, "attendance.xlsx");
  };

  return (
    <>
      <div className="admin bg-white">
        <Header />
        <div className="admin-content h-full overflow-y-auto">
          {isLoading ? (
            <Loader />
          ) : (
            <>
              <div className="data-filter bg-white flex items-center justify-center gap-3 mt-5 px-2">
                <div className="date w-[70%] flex items-center gap-2">
                  <DatePicker
                    className="w-full rounded text-sm text-[#232323] border-gray-300 focus:border-gray-300 focus:ring-0"
                    selected={startDate}
                    onChange={(date) => setStartDate(date)}
                  />
                  <DatePicker
                    className="w-full rounded text-sm text-[#232323] border-gray-300 focus:border-gray-300 focus:ring-0"
                    selected={endDate}
                    onChange={(date) => setEndDate(date)}
                  />
                </div>
                <div className="upload">
                  <button
                    className="rounded bg-brand text-white flex items-center gap-2 capitalize p-2"
                    onClick={exportXlsx}
                    disabled={employees?.length ? false : true}
                  >
                    <img
                      className="w-4 h-4"
                      src={exportIcon}
                      alt="exportIcon"
                    />
                    export
                  </button>
                </div>
              </div>
              {employees?.length ? (
                <>
                  <div className="table-data w-full mt-5">
                    <div className="table-header w-full bg-brand flex items-center justify-between gap-2 p-2">
                      <div className="th-col w-[10%] text-[11px] text-white font-bold capitalize">
                        code
                      </div>
                      <div className="th-col w-1/4 text-[11px] text-white text-center font-bold capitalize">
                        name
                      </div>
                      <div className="th-col w-1/4 text-[11px] text-white text-center font-bold capitalize">
                        phone
                      </div>
                      <div
                        className="th-col w-1/5 text-[11px] text-white text-center font-bold cursor-pointer capitalize flex items-center gap-[2px]"
                        onClick={sortCheckIn}
                      >
                        checkin
                        {!toggleCheckInIcon ? (
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 24 24"
                            strokeWidth={1.5}
                            stroke="currentColor"
                            className="w-3 h-3"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              d="M4.5 10.5L12 3m0 0l7.5 7.5M12 3v18"
                            />
                          </svg>
                        ) : (
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 24 24"
                            strokeWidth={1.5}
                            stroke="currentColor"
                            className="w-3 h-3"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              d="M19.5 13.5L12 21m0 0l-7.5-7.5M12 21V3"
                            />
                          </svg>
                        )}
                      </div>
                      <div
                        className="th-col w-1/5 text-[11px] text-white text-center font-bold cursor-pointer capitalize flex items-center gap-[2px]"
                        onClick={sortCheckOut}
                      >
                        checkout
                        {!toggleCheckoutIcon ? (
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 24 24"
                            strokeWidth={1.5}
                            stroke="currentColor"
                            className="w-3 h-3"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              d="M4.5 10.5L12 3m0 0l7.5 7.5M12 3v18"
                            />
                          </svg>
                        ) : (
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 24 24"
                            strokeWidth={1.5}
                            stroke="currentColor"
                            className="w-3 h-3"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              d="M19.5 13.5L12 21m0 0l-7.5-7.5M12 21V3"
                            />
                          </svg>
                        )}
                      </div>
                    </div>
                    <div className="table-body">
                      {employees.map((item, index) => (
                        <div
                          className="row border-b-2 border-solid border-gray-300 flex items-center justify-between gap-2 p-2"
                          key={index}
                        >
                          {db_fields.map((dbField, index) => (
                            <div
                              className={`col ${dbField === "outlet_code"
                                ? "w-[10%]"
                                : dbField.match(/check/g) !== null
                                  ? "w-1/5"
                                  : "w-1/4"
                                } text-[11px] text-center truncate`}
                              key={index}
                            >
                              {dbField === "date" &&
                                new Date(item[dbField]).toDateString() !==
                                "Invalid Date"
                                ? new Date(item[dbField]).toLocaleDateString(
                                  "en-UK",
                                  {
                                    dateStyle: "medium",
                                  }
                                )
                                : (dbField === "checkin" ||
                                  dbField === "checkout") &&
                                  new Date(item[dbField]).toDateString() !==
                                  "Invalid Date"
                                  ? new Date(item[dbField]).toLocaleTimeString(
                                    "en-US"
                                  )
                                  : item[dbField]}
                            </div>
                          ))}
                        </div>
                      ))}
                    </div>
                  </div>
                </>
              ) : (
                <div className="no-data text-center mt-20">
                  <div className="icon">
                    <svg
                      version="1.1"
                      id="Layer_1"
                      xmlns="http://www.w3.org/2000/svg"
                      className="w-28 h-28 mx-auto"
                      viewBox="0 0 32 32"
                      enableBackground="new 0 0 32 32"
                    >
                      <g>
                        <path
                          fill="#828282"
                          d="M16-0.034C7.159-0.034-0.035,7.158-0.035,16S7.159,32.034,16,32.034S32.035,24.842,32.035,16
        S24.841-0.034,16-0.034z M16,30.966C7.748,30.966,1.035,24.252,1.035,16S7.748,1.034,16,1.034S30.965,7.748,30.965,16
        S24.252,30.966,16,30.966z"
                        />
                        <path
                          fill="#828282"
                          d="M16.163,19.823c-2.789,0-5.477,1.179-7.374,3.235c-0.2,0.217-0.187,0.555,0.031,0.755
        c0.216,0.2,0.554,0.188,0.755-0.03c1.695-1.838,4.096-2.892,6.587-2.892c2.529,0,4.956,1.081,6.656,2.967
        c0.105,0.116,0.251,0.176,0.397,0.176c0.128,0,0.256-0.045,0.358-0.138c0.219-0.197,0.237-0.535,0.039-0.755
        C21.709,21.032,18.994,19.823,16.163,19.823z"
                        />
                        <path
                          fill="#828282"
                          d="M10.5,16.5c1.103,0,2-0.897,2-2s-0.897-2-2-2s-2,0.897-2,2S9.397,16.5,10.5,16.5z M10.5,13.5
        c0.551,0,1,0.448,1,1s-0.449,1-1,1s-1-0.448-1-1S9.949,13.5,10.5,13.5z"
                        />
                        <path
                          fill="#828282"
                          d="M21.5,16.5c1.103,0,2-0.897,2-2s-0.897-2-2-2s-2,0.897-2,2S20.397,16.5,21.5,16.5z M21.5,13.5
        c0.551,0,1,0.448,1,1s-0.449,1-1,1s-1-0.448-1-1S20.949,13.5,21.5,13.5z"
                        />
                      </g>
                    </svg>
                  </div>
                  <div className="text text-gray-400 font-semibold capitalize mt-5">
                    no attendance data found!
                  </div>
                </div>
              )}
            </>
          )}
        </div>
      </div>
    </>
  );
};

export default Admin;
